import React from "react";

const StandardComparator = ({
  current,
  previous,
  inverse = false,
  comparisonLabel = "Last Month",
  copy,
}) => {
  // Calculate percentage difference
  const difference = current - previous;
  let percentage = 0;
  if (previous !== 0) {
    percentage = (difference / previous) * 100;
  } else if (current !== 0) {
    percentage = 100;
  }
  const isIncrease = difference > 0;

  // For Spending: Increase is BAD (Red/Negative).
  const isNegativeState = inverse ? !isIncrease : isIncrease;

  // Constants for colors to match Figma
  const colors = {
    red: {
      bg: "#D32F2F",
      text: "#D32F2F",
      boxBg: "#FFEBEB",
      boxBorder: "#FFB8B8",
    },
    green: {
      bg: "#059669",
      text: "#059669",
      boxBg: "#ECFDF5",
      boxBorder: "#A7F3D0",
    },
  };

  const theme = isNegativeState ? colors.red : colors.green;
  const formattedPercentage = Math.abs(percentage).toFixed(1);
  const trendLabel = difference >= 0 ? copy?.up : copy?.down;
  const comparisonText = trendLabel
    ? trendLabel
        .replace("{percentage}", formattedPercentage)
        .replace("{period}", comparisonLabel)
    : `${isIncrease ? "+" : ""}${percentage.toFixed(1)}% vs ${comparisonLabel}`;

  const styles = {
    container: {
      backgroundColor: theme.boxBg,
      border: `1px solid ${theme.boxBorder}`,
    },
    iconContainer: {
      // FIXED: Color is applied to the background
      backgroundColor: theme.bg,
    },
    iconImg: {
      // FIXED: The SVG itself is now always white
      filter: "brightness(0) invert(1)",
      // Flip icon vertically if spending went down
      transform: isIncrease ? "none" : "scaleY(-1)",
    },
    percentage: {
      color: theme.text,
    },
    label: {},
  };

  return (
    <div style={styles.container} className="streamline-standard-comparator">
      <div
        style={styles.iconContainer}
        className="streamline-standard-comparator-icon-container"
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/icons/moving.svg`}
          alt="Trend Icon"
          style={styles.iconImg}
          className="streamline-standard-comparator-icon"
        />
      </div>
      <div className="streamline-standard-comparator-content">
        <span style={styles.percentage} className="percentage">
          {trendLabel
            ? comparisonText
            : `${isIncrease ? "+" : ""}${percentage.toFixed(1)}%`}
        </span>
        {!trendLabel && (
          <span style={styles.label} className="span-label">
            vs {comparisonLabel}
          </span>
        )}
      </div>
    </div>
  );
};

export default StandardComparator;
